import type { StateCreator } from 'zustand';

import type { WorkspaceStore } from '../workspaceStore';
import {
  emptyIdentitySnapshot,
  type WorkspaceIdentitySnapshot,
} from '../types';

export type IdentitySlice = {
  identity: WorkspaceIdentitySnapshot;
  setWorkspaceIdentity: (next: Partial<WorkspaceIdentitySnapshot>) => void;
  resetWorkspaceIdentity: () => void;
};

export const createIdentitySlice: StateCreator<
  WorkspaceStore,
  [],
  [],
  IdentitySlice
> = set => ({
  identity: emptyIdentitySnapshot(),
  setWorkspaceIdentity: next =>
    set(state => ({
      identity: {
        ...state.identity,
        ...next,
      },
    })),
  resetWorkspaceIdentity: () => set({ identity: emptyIdentitySnapshot() }),
});
